import { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { Box, RefreshOutline } from '@bonusly/design-system';

interface MobileResetVideoButtonProps {
	onRestartRecording: () => void;
}

export const MobileResetVideoButton: FC<MobileResetVideoButtonProps> = ({ onRestartRecording }) => {
	const { t } = useTranslation('video');

	return (
		<Box position="absolute" display="flex" flexDirection="row" bottom="20px" left="20px">
			<Box
				px="8px"
				py="4px"
				bg="rgba(0, 0, 0, 0.3)"
				m={2}
				borderRadius="sm"
				color="white"
				display="flex"
				flexDirection="row"
				alignItems="center"
				cursor="pointer"
				onClick={onRestartRecording}
				_hover={{ bg: 'rgba(0, 0, 0, 0.4)' }}
				data-testid="restart-button-recording"
			>
				<RefreshOutline mr={1} />
				{t('modal.actions.restart')}
			</Box>
		</Box>
	);
};
